import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { CdnBaseUrl } from '@deltek/specification-client/core/Utilities/urlUtils'
import Button from '@material-ui/core/Button'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'
import { Link } from 'react-router-dom'

const CdnClientBaseUrl = `${CdnBaseUrl}/knowledgepoint/client`

const useStyles = makeStyles((theme: Theme) => ({
    noDataWrapperContainer: {
        backgroundColor: '#FFFDFA',
    },
    noDataContainer: {
        paddingTop: theme.spacing(18),
        backgroundColor: '#FFFDFA',
        paddingBottom: theme.spacing(18.4),
    },
    noDataElementContainer: {
        width: pxToRem(246),
        backgroundColor: '#B7A99A',
    },
    noDataElementColumn: {
        backgroundColor: '#B7A99A',
    },
    noDataContentColumn: {
        margin: 'auto',
    },
    actionButton: {
        borderRadius: pxToRem(100),
        background: '#185E8E',
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: '#185E8E',
        },
        fontSize: pxToRem(18),
        margin: 'auto',
        height: pxToRem(44),
        width: pxToRem(200),
        padding: theme.spacing(1.25),
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: pxToRem(24),
        letterSpacing: '0rem',
    },
    textContent: {
        color: '#304959',
        fontSize: pxToRem(18),
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: pxToRem(24),
        letterSpacing: '0rem',
        marginTop: theme.spacing(1.2225),
        marginBottom: theme.spacing(4.25),
    },
    noWorkspaceDataIcon: {
        height: pxToRem(172),
        width: pxToRem(276),
        color: '#ffffff',
    },
    buttonLink: {
        textDecoration: 'none',
    },
    imageLinkContainer: {
        textDecoration: 'none',
    },
}))

const WorkspaceProgressNoData = () => {
    const classes = useStyles()

    return (
        <GridContainer
            direction="row"
            role="row"
            className={classes.noDataWrapperContainer}
        >
            <GridItem className={classes.noDataElementContainer}>
                <></>
            </GridItem>
            <GridItem className={classes.noDataContentColumn}>
                <GridContainer
                    className={classes.noDataContainer}
                    role="cell"
                    alignItems="center"
                    justifyContent="center"
                    direction="column"
                    data-testid="dvWorkspaceProgressNoData"
                >
                    <GridItem>
                        <Link
                            to={'workspace'}
                            className={classes.imageLinkContainer}
                        >
                            <img
                                src={`${CdnClientBaseUrl}/no_record_icon.svg`}
                                alt="no data icon"
                                className={classes.noWorkspaceDataIcon}
                            />
                        </Link>
                    </GridItem>
                    <GridItem>
                        <p className={classes.textContent}>
                            You Haven't Added Any Elements to Your Project.{' '}
                            <br />
                            Start Building Your Project to View Progress.
                        </p>
                    </GridItem>
                    <GridItem>
                        <Link to={'workspace'} className={classes.buttonLink}>
                            <Button className={classes.actionButton}>
                                Go To Workspace
                            </Button>
                        </Link>
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    )
}

export default React.memo(WorkspaceProgressNoData)
